import React from 'react';
import classNames from 'classnames';
import DurationFormat from '../../../../components/DurationFormat';
import { BreakDeductionStatusIndicator } from '../../../../components/AutoBreaks/BreakDeductionStatusIndicator';
import { AutoBreakDeductionStatus } from '../../../../pages/TimeTracking/TimeTrackingEntries/logic/types';

type Props = {
  value: number;
  breakDeductionStatus?: AutoBreakDeductionStatus;
  id?: string;
};

export const TrackedTimeCell: React.FC<React.PropsWithChildren<Props>> = ({
  value,
  breakDeductionStatus,
  id,
}) => {
  return (
    <div className={classNames('d-flex gap-1 align-items-center')}>
      <DurationFormat minutes={value} />
      <BreakDeductionStatusIndicator status={breakDeductionStatus} id={id} />
    </div>
  );
};
